'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:ui:loadingStop');
}

var _invoke = require('../invoke');

/**
 * 关闭加载动画
 *
 * 支持版本
 * + iHotel/5.8+
 *
 * @memberof ui
 * @static
 * @name loadingStop
 * @return {Undefined}
 * @example
 *  hbnb.ui.loadingStop();
 */
module.exports = function() {
    if (process.env.NODE_ENV !== 'production') {
        debug('stop');
    }

    _invoke('ui', 'loading_stop');
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/ui/loading-stop.js
// module id = 652
// module chunks = 0